import { cn } from 'src/lib/utils';

import { useEscrowDashboardCard } from '../model/context';

const InfoList = () => {
  const { config } = useEscrowDashboardCard();
  const { infoListItems } = config;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {infoListItems.map(({ label, value, emptyValue, icon: Icon }, index) => (
        <div key={index} className={cn('text-xs pr-2', index !== 0 && 'sm:pl-2', index === 1 && 'sm:border-l')}>
          <div className="text-gray-500 flex items-center gap-0.5 mb-1">
            <Icon className="size-4" />
            <span>{label}</span>
          </div>
          <div className={cn('text-sm font-medium text-gray-700', !value && 'text-gray-400 font-light')}>
            {value || emptyValue}
          </div>
        </div>
      ))}
    </div>
  );
};

export { InfoList };
